export function loadAppShellKitsCopilot() {
    return import("./chat/InlineKitsCopilot");
}
